import LoginHistoryContainer from "./LoginHistoryContainer";

export default LoginHistoryContainer;
